export default {
  'edamame': {
    type: 'main',
    name: '枝村 真人',
    kana: 'エダマメ',
    en: 'EDAMAME',
    fukidashi: '「エダマメでねェッ！<br>　枝村だッ！」',
    description: '善良な老人や旅行客をカモに詐欺を働き生計を立てる、自称・日本一の天才詐欺師。元来の性格は、真面目でお人好し。趣味はカプセルトイのフィギュア集め。コーヒー好き。',
    cv: '小林千晃',
    image: '/assets/images/character-edamame.png',
    icon: '/assets/images/character-edamame-icon.png'
  },
  'laurent': {
    type: 'main',
    name: 'ローラン・ティエリー',
    kana: '',
    en: 'LAURENT',
    fukidashi: '「こう見えて、僕らは<br>悪党しか騙さないんでね」',
    description: '世界中を飛び回る、フランス人の信用詐欺師（コンフィデンスマン）。どんな状況でも取り乱すことなく、うまく切り抜ける。お洒落でジョーク好き。浅草観光をしているときに、枝村から詐欺のターゲットにされるが…',
    cv: '諏訪部順一',
    image: '/assets/images/character-laurent.png',
    icon: '/assets/images/character-laurent-icon.png'
  },
  'abbie': {
    type: 'main',
    name: 'アビゲイル・ジョーンズ',
    kana: 'アビー',
    en: 'ABBIE',
    fukidashi: '「信じられるのは<br>　自分だけ」',
    description: 'しなやかで引き締まった体躯と、抜群の運動能力をもつ信用詐欺師（コンフィデンスウーマン）。ぶっきらぼうで好戦的。幼少期のある記憶を、心に秘めている。',
    cv: '藤原夏海',
    image: '/assets/images/character-abbie.png',
    icon: '/assets/images/character-abbie-icon.png'
  },
  'cynthia': {
    type: 'main',
    name: 'シンシア・ムーア',
    kana: '',
    en: 'CYNTHIA',
    fukidashi: '「いいことしたあとの<br>　ワインはおいしいわ」',
    description: '優しく抱擁力のある信用詐欺師（コンフィデンスウーマン）。その美貌と演技力でターゲットの懐に入り込む。資産家でもあり、多くの不動産を所有している。飲むと陽気に絡んでくる愛飲家。',
    cv: '園崎未恵',
    image: '/assets/images/character-cynthia.png',
    icon: '/assets/images/character-cynthia-icon.png'
  },
  'pola': {
    type: 'main',
    name: 'ポーラ・ディキンス',
    kana: '',
    en: 'POLA',
    fukidashi: '「ローランの優しさは<br>　うわべだけよ」',
    description: '美しく、知的なFBI敏腕捜査官。ローランを逮捕すべく、ロサンゼルスに現れる。したたかに立ち回り、ロス市警にも一目置かれている。',
    cv: '園崎未恵',
    image: '/assets/images/character-pola.png',
    icon: '/assets/images/character-pola-icon.png'
  },
  'cassano': {
    type: 'sub',
    name: 'エディ・カッサーノ',
    description:
      'イタリア系アメリカ人の映画プロデューサー。<br>' +
      'その実態は、ハリウッドでドラッグを流通させ、裏社会を牛耳るマフィアのボス。<br>' +
      '新型合成麻薬“サクラマジック”の噂を聞きつけ、ローランに近づく。',
    cv: '斧 アツシ',
    image: '/assets/images/character-cassano.jpg'
  },
  'kudo': {
    type: 'sub',
    name: '工藤',
    description:
      '柄で陽気なおじさん。<br>' +
      '枝村と組んで詐欺をはたらいていたが、ローランの仕事に触発され一味に加わりたいと志願。<br>' +
      '見た目によらず勉強家で、枝村のことを「さん付け」で呼ぶ。',
    cv: '多田野曜平',
    image: '/assets/images/character-kudo.jpg'
  },
  'kim': {
    type: 'sub',
    name: 'キム・シウォン',
    description:
      '熟練の信用詐欺師（コンフィデンスウーマン）。<br>' +
      'かつてはその魅惑の身体を武器にハニートラップで男共を虜にしていた。<br>' +
      '豪胆な性格で、ムードメーカーでもある。ローランとは付き合いが長い。',
    cv: 'くじら',
    image: '/assets/images/character-kim.jpg'
  },
  'anderson': {
    type: 'sub',
    name: 'アンダーソン警部',
    description:
      '長年カッサーノを追うロス市警のコワモテ警部。部下への気配りは抜かりない。<br>' +
      'ハンバーガーはピクルス抜き派。',
    cv: '谷 昌樹',
    image: '/assets/images/character-anderson.jpg'
  },
  'salazar': {
    type: 'sub',
    name: 'サラザール',
    description:
      'カッサーノのボディーガードを任される屈強な男。<br>' +
      '妻を亡くし、仕方なく息子を施設に預けている。以前はギャングのボスをしていたことも。',
    cv: '竹内良太',
    image: '/assets/images/character-salazar.jpg'
  },
  'tom': {
    type: 'sub',
    name: 'トム',
    description: '普段は養護施設で過ごしているが、週一回のサラザールとの面会を楽しみにしている。将来は尊敬する父と同じ、VIPのボディガードになるのが夢。',
    cv: '種﨑敦美',
    image: '/assets/images/character-tom.jpg'
  },
  'sam': {
    type: 'sub',
    name: 'サム・イブラヒム',
    description: 'パスファインダーエアレースのオーナー兼プロモーター。弟の才能と自身の商才でエアレースを牛耳る。クラークとは対照的に落ち着きがあり疑り深い。自称、根っからの悪人。',
    cv: '小松史法',
    image: '/assets/images/character-sam.jpg'
  },
  'clark': {
    type: 'sub',
    name: 'クラーク・イブラヒム',
    description: '兄のサムが主催するパスファインダーエアレースの看板パイロット。甘いマスクとその才能でアイドル並みの人気を誇る。性格は明るく社交的で女性に目がない。',
    cv: '小林親弘',
    image: '/assets/images/character-clark.jpg'
  },
  'lewis': {
    type: 'sub',
    name: 'ルイス・ミューラー',
    description: 'クラークのライバルとして活躍するレースパイロットだったが、レース中の事故により車椅子での生活を余儀なくされる。悪人面と口の悪さで、レース外でも人気者だった。',
    cv: '乃村健次',
    image: '/assets/images/character-lewis.jpg'
  },
  'isabelle': {
    type: 'sub',
    name: 'イザベル・ミューラー',
    description: 'ルイスの妻。夫ルイスが事故により情緒不安定になってしまったことを気がかりにしている。最近はルイスの悪態に、ほとほと手を焼いている。',
    cv: '佐古真弓',
    image: '/assets/images/character-isabelle.jpg'
  },
  'coleman': {
    type: 'sub',
    name: 'ジェームズ・コールマン',
    description: '美術界の007とあだ名される、一流の鑑定士兼画商兼オークショニア。<br>イギリスでは、彼に認められない画家は美術界で生きて行くのは難しいと言われている。パトロンであるファラの膝枕で寝るのが好き。',
    cv: '安原義人',
    image: '/assets/images/character-coleman.jpg'
  },
  'sebastian': {
    type: 'sub',
    name: 'セバスチャン',
    description: 'エダマメが滞在する下宿先の主人。フランス語しか話せないが、ジェスチャーゲームは得意。先立たれた嫁が作った借金に、お手上げ状態。',
    cv: 'ファブリース・ブティック',
    image: '/assets/images/character-sebastian.jpg'
  },
  'marie': {
    type: 'sub',
    name: 'マリー',
    description: 'エダマメが滞在する下宿先の娘。英語とフランス語が喋れるので、観光客とのコミュニケーションはバッチリ。思い出のある、暖炉に掛けた絵を気に入っている。',
    cv: '若井友希',
    image: '/assets/images/character-marie.jpg'
  },
  'thomas': {
    type: 'sub',
    name: 'トーマス・メイヤー',
    description: '世間から認められず、貧乏画家として暮らしていた。しかし、とある鑑定士に見出されたことで人生が一変する。安い豆の缶詰が三度の飯より大好き。',
    cv: '平川大輔',
    image: '/assets/images/character-thomas.jpg'
  },
  'fara': {
    type: 'sub',
    name: 'ファラ・ブラウン',
    description: 'ジェームズ・コールマンを心から信頼し、彼の美術オークションに足を運ぶ。 父親が興したファッションメーカーの二代目社長を務める。虫が苦手。',
    cv: '本田貴子',
    image: '/assets/images/character-fara.jpg'
  },
  'akemi': {
    type: 'sub',
    name: '朱雀アケミ',
    description: '人身売買を生業とする犯罪組織『朱雀連合会』の会長。<br>白い着物を粋に着こなし、鋭い目つきとその風格はさながら裏社会の女帝そのもの。愛煙家。',
    cv: '高島雅羅',
    image: '/assets/images/character-akemi.jpg'
  },
  'ishigami': {
    type: 'sub',
    name: '石神',
    description: '貿易会社『スカーレット商会』の社長。<br>柔和な顔と人当たりの良い話し方を持ちあわせており、服役していた過去を持つ枝村を快く雇う。<br>怒らせたら怖いが、酒には弱い。',
    cv: '関智一',
    image: '/assets/images/character-ishigami.jpg'
  },
  'liu': {
    type: 'sub',
    name: '劉暁',
    description: '『上海龍虎幇（シャンハイロンフーバン）』の社長。上海における朱雀連合会の下部組織を近年急成長させ、ダミー会社を上場企業化したのち独立自営まで始める。上海経済界の名士と謳われる人物で立派な福耳の持ち主。最近、潔癖症を自覚したらしい。',
    cv: '阪口周平',
    image: '/assets/images/character-liu.jpg'
  },
  'chen': {
    type: 'sub',
    name: '陳尭',
    description: '『上海龍虎幇（シャンハイロンフーバン）』の幹部であり劉の右腕。<br>派手な金髪に大きな傷のある顔と、強気な姿勢で相手に畏怖を与える。性格も感情的で血の気が多い。煙草であればなんでも吸う。',
    cv: '最上嗣生',
    image: '/assets/images/character-chen.jpg'
  },
  'oz': {
    type: 'sub',
    name: 'オズ',
    description: '枝村の父。本名は尾崎誠司。<br>枝村が学生の頃、弁護士をしていたはずなのに人身売買の容疑で逮捕された。<br>長いこと日本から姿を消していたが、ある日上海龍虎幇のエージェントとして現れる…',
    cv: '咲野俊介',
    image: '/assets/images/character-oz.jpg'
  },
  'dorothy': {
    type: 'sub',
    name: 'ドロシー',
    description: 'ローランをコンフィデンスマンの世界に誘った自称天才コンフィデンスレディ。<br>とてもおしゃべりであり、一度口を開くとなかなか止まらないムードメーカー。二日間黙ると死んでしまうらしい。',
    cv: '小松由佳',
    image: '/assets/images/character-dorothy.jpg'
  },
  index: {
    main: [
      {
        id: 'edamame',
        icon: '/assets/images/character-edamame-icon.png'
      },
      {
        id: 'laurent',
        icon: '/assets/images/character-laurent-icon.png'
      },
      {
        id: 'abbie',
        icon: '/assets/images/character-abbie-icon.png'
      },
      {
        id: 'cynthia',
        icon: '/assets/images/character-cynthia-icon.png'
      }
      /* {
        id: 'pola',
        icon: '/assets/images/character-pola-icon.png'
      } */
    ],
    case: [
      {
        case: 'CASE 4',
        character: [
          {
            id: 'akemi',
            icon: '/assets/images/character-akemi-icon.jpg'
          },
          {
            id: 'ishigami',
            icon: '/assets/images/character-ishigami-icon.jpg'
          },
          {
            id: 'liu',
            icon: '/assets/images/character-liu-icon.jpg'
          },
          {
            id: 'chen',
            icon: '/assets/images/character-chen-icon.jpg'
          },
          {
            id: 'oz',
            icon: '/assets/images/character-oz-icon.jpg'
          },
          {
            id: 'dorothy',
            icon: '/assets/images/character-dorothy-icon.jpg'
          }
        ]
      },
      {
        case: 'CASE 3',
        character: [
          {
            id: 'coleman',
            icon: '/assets/images/character-coleman-icon.jpg'
          },
          {
            id: 'sebastian',
            icon: '/assets/images/character-sebastian-icon.jpg'
          },
          {
            id: 'marie',
            icon: '/assets/images/character-marie-icon.jpg'
          },
          {
            id: 'thomas',
            icon: '/assets/images/character-thomas-icon.jpg'
          },
          {
            id: 'fara',
            icon: '/assets/images/character-fara-icon.jpg'
          }
        ]
      },
      {
        case: 'CASE 2',
        character: [
          {
            id: 'sam',
            icon: '/assets/images/character-sam-icon.jpg'
          },
          {
            id: 'clark',
            icon: '/assets/images/character-clark-icon.jpg'
          },
          {
            id: 'lewis',
            icon: '/assets/images/character-lewis-icon.jpg'
          },
          {
            id: 'isabelle',
            icon: '/assets/images/character-isabelle-icon.jpg'
          }
        ]
      },
      {
        case: 'CASE 1',
        character: [
          {
            id: 'cassano',
            icon: '/assets/images/character-cassano-icon.png'
          },
          {
            id: 'kudo',
            icon: '/assets/images/character-kudo-icon.jpg'
          },
          {
            id: 'kim',
            icon: '/assets/images/character-kim-icon.jpg'
          },
          {
            id: 'anderson',
            icon: '/assets/images/character-anderson-icon.jpg'
          },
          {
            id: 'salazar',
            icon: '/assets/images/character-salazar-icon.jpg'
          },
          {
            id: 'tom',
            icon: '/assets/images/character-tom-icon.jpg'
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/data/character.js